const MAX_ASSETS_EXCLUDE_LIST_ALLOWED = 50;

export const validateWholeNumber = value => Number.isSafeInteger(Number(value)) || 'Value should be a whole number';

export const validateNumber = value => !isNaN(value) || 'Value should be a number';

export const validateListLength = (value) => {
    if(value && value.length >= MAX_ASSETS_EXCLUDE_LIST_ALLOWED){
        return `The list cannot exceed ${MAX_ASSETS_EXCLUDE_LIST_ALLOWED} values`
    }
    return true;
};
